import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Users, Award, HeartPulse } from 'lucide-react';
import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';




const Services = () => {
  const list = [
    {
      title: "Exhibition Clinics",
      desc: "Providing free dental check-ups and awareness at major industrial exhibitions in Vijayawada and Hyderabad.",
      icon: <MapPin className="text-primary" />
    },
    {
      title: "Free Rural Camps",
      desc: "Taking advanced dental care to the doorstep of rural communities through dedicated mass check-up camps.",
      icon: <Users className="text-primary" />
    },
    {
      title: "Civic Recognition",
      desc: "Our initiatives have been supported and inaugurated by esteemed figures like the District Collector and Commissioner of Police.",
      icon: <Award className="text-primary" />
    },
    {
      title: "Mass Awareness",
      desc: "Focusing on spreading essential knowledge about oral hygiene and preventive dental health across all sections of society.",
      icon: <HeartPulse className="text-primary" />
    },
  ];

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 60,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut",
      },
    },
  };


  return (
    <section id="about" className="py-20 bg-white pb-50 2xl:pb-[50px]">   {/* ← only added pb-0 */}
      <div className="max-w-7xl mx-auto px-12">

        {/* Header */}
        <motion.div
          className="text-center pt-24 mb-12"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >
          <motion.h2
            className="text-3xl md:text-5xl font-black text-slate-900 mb-4 uppercase"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.2 }}
          >
            Community Outreach & Awareness
          </motion.h2>

          <motion.p
            className="text-slate-500 max-w-3xl mx-auto text-lg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.2 }}
          >
            Dedicated to dental health awareness through mass check-up clinics in industrial exhibitions and rural camps.
          </motion.p>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {list.map((s, i) => (
            <motion.div
              key={i}
              initial={{
                opacity: 0,
                y: 50,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
                amount: 0.2,
              }}
              transition={{
                duration: 0.2,
                delay: i * 0.05,
              }}
              whileHover={{
                y: -4,
                scale: 1.03,
              }}
              className="p-8 rounded-3xl bg-slate-50 hover:bg-blue-100 transition-all border border-transparent hover:border-blue-400 group shadow-sm hover:shadow-xl"
            >
              <motion.div
                whileHover={{
                  rotate: 8,
                  scale: 1.15,
                }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                }}
                className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm"
              >
                {s.icon}
              </motion.div>

              <motion.h3
                className="text-xl font-bold mb-3"
                whileHover={{
                  color: "#2c51f7",
                }}
              >
                {s.title}
              </motion.h3>

              <p className="text-slate-600 text-sm leading-relaxed">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>



      </div>
    </section>
  );
};

export default Services;